import React, { useState } from 'react';
import CalendarComponent from './CalendarComponent';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import { Link } from 'react-router-dom';
  import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

const Cleander = () => {
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState({ title: '', start: '', end: '' });
  const [modalVisible, setModalVisible] = useState(false);
  
  const handleAddEvent = (event) => {
    setEvents([...events, event]); // Add new event to the list of events
    setModalVisible(false); // Close modal after adding event
  };

  return (
    <>
      {/* Add New Event Button with Style */}
      <div className="text-center ">
        
       
      </div>

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="container">

            

<FullCalendar
  plugins={[dayGridPlugin]}
  initialView="dayGridMonth"
  events={[
    { title: 'Event 1', date: '2025-08-04' },
    { title: 'Event 2', date: '2025-08-07' }
  ]}
/>

                  <button
          onClick={() => setModalVisible(true)}
          className="btn btn-sm btn-outline-primary shadow-sm border-0 mb-4 mt-4 bg-white rounded-3 hover-custom"
        >
          Add New Event
        </button> <Link to={'/'}
          
          className="btn btn-sm btn-outline-primary shadow-sm border-0 mb-4 mt-4 bg-white rounded-3 hover-custom"
        >
          go to home
        </Link>
              <div className="contentDiv card p-5">
                {/* You can add some additional content here */}
{/*                
          <CalendarComponent
                events={events}
                setEvents={setEvents}
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                newEvent={newEvent}
                setNewEvent={setNewEvent}
                handleAddEvent={handleAddEvent} // Pass down the handler for adding events
              /> */}
              </div>

            
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cleander;
